import { render, staticRenderFns } from "./ownerManagement.vue?vue&type=template&id=1069de0e&"
import script from "./ownerManagement.vue?vue&type=script&lang=js&"
export * from "./ownerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports